import { useCallback } from 'react';

import { snackbarManager } from './snackbarManager';
import { ShowSnackbarOptions } from './types';

export const useSnackbar = () => {
  const showSnackbar = useCallback((options: ShowSnackbarOptions) => {
    snackbarManager.show(options);
  }, []);

  const dismissSnackbar = useCallback(() => {
    snackbarManager.dismiss();
  }, []);

  return {
    showSnackbar,
    dismissSnackbar,
  };
};
